import 'lazysizes';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faWaze } from '@fortawesome/free-brands-svg-icons'
import { faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleUp } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faCalendarPlus } from '@fortawesome/free-regular-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons'
import { faUniversity } from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faTag } from '@fortawesome/free-solid-svg-icons'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faSlidersH } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { faHourglassStart } from '@fortawesome/free-solid-svg-icons'
import { faChild } from '@fortawesome/free-solid-svg-icons'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { faPoundSign } from '@fortawesome/free-solid-svg-icons'
import { faMedal } from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { faUserShield } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'
import { faBalanceScale } from '@fortawesome/free-solid-svg-icons'
import { faChartLine } from '@fortawesome/free-solid-svg-icons'
import { faHandshake } from '@fortawesome/free-solid-svg-icons'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'
import { faLaptop } from '@fortawesome/free-solid-svg-icons'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { faRocket } from '@fortawesome/free-solid-svg-icons'
import feather from 'feather-icons';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js'
import lottie from 'lottie-web/build/player/lottie_svg';
import 'jquery-validation';
import 'bootstrap/js/dist/modal';
/* import 'bootstrap/js/dist/collapse'; */
window.captchaSuccess = captchaSuccess;

library.add(faCalendar, faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faQuestionCircle, faTimes, faSlidersH, faPlus, faMinus, faTag, faTags, faSearch, faClock, faInfoCircle, faUniversity, faLinkedinIn, faMapMarkedAlt, faFacebookF, faFacebook, faYoutube, faComments, faArrowRight, faCalendarPlus, faCaretRight, faChevronRight, faInstagram, faWaze, faGoogle, faChevronCircleUp, faWhatsapp, faPhone, faEnvelope, faMapMarkerAlt, faClipboardList, faHourglassStart, faChild, faPencilAlt, faPoundSign, faMedal, faCalendarAlt, faUserShield, faHome, faGraduationCap, faLanguage, faFileAlt, faEdit, faGlobe, faBalanceScale, faChartLine, faHandshake, faBook, faStar, faChalkboardTeacher, faLaptop, faPlayCircle, faRocket)
dom.watch()

feather.replace()

jQuery.validator.setDefaults({
  onkeyup: false,
  errorElement: 'div',
  errorClass: 'invalid-feedback',

  errorPlacement: function (error, element) {
    element.closest('.form-group').append(error);
  },
  highlight: function (element, errorClass, validClass) {
    $(element).removeClass('is-valid').addClass('is-invalid');
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).removeClass('is-invalid').addClass('is-valid');
    $(element).next('.invalid-feedback').remove();
  }
});

$.validator.addMethod("notEqualTo", function (value, element, param) {
  return this.optional(element) || !$.validator.methods.equalTo.call(this, value, element, param);
}, "Your last name cannot be the same as your first name.");

//Variables Init
var $blog_list = $("#blog_list");
var blog_list_pagination = 1;
var $workshop_list = $("#workshop_list");
var workshop_list_pagination = 1;

document.addEventListener("DOMContentLoaded", function () {
  var elem = document.getElementById("header-logo");
  lottie.loadAnimation({
    container: elem, // the dom element that will contain the animation
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: '/PrepWorks-logo-bm.json' // the path to the animation json
  });

  // Getting Country data from HTTP header
  var visitor_country = $("#visitor-country").data('visitor-country') || "my";
  // Initializing Phone Number
  if ($("#phone_field").length) {
    var input = document.querySelector("#phone_field");
    var user_telephone_iti = intlTelInput(input, {
      initialCountry: visitor_country,
      autoPlaceholder: "off",
      separateDialCode: true,
      customContainer: "w-100",
      preferredCountries: ["my", "sg"],
      utilsScript: "../intl-tel-input/build/js/utils.js"
    });

    if ($("#phone_field").val() != "") {
      user_telephone_iti.setNumber($("#phone_field").val());
    }

    jQuery.validator.addMethod("phone", function (value, element) {
      return this.optional(element) || user_telephone_iti.isValidNumber();
    }, "Please enter a valid phone number.");

  }
  function normalizeSlideHeights() {
    var $win = $(window);
    var winWidth = $win.width();

    if (winWidth <= 992)
      return;

    $('.carousel').each(function () {
      var items = $('.carousel-equal-height', this);
      // reset the height
      items.css('min-height', 0);
      // set the height
      var maxHeight = Math.max.apply(null,
        items.map(function () {
          return $(this).outerHeight()
        }).get());
      items.css('min-height', maxHeight + 'px');
    })
  }

  $(window).on(
    'load resize orientationchange',
    normalizeSlideHeights);

  if($("#shooting-stars").length){
    particlesJS("shooting-stars", {
      "particles": {
        "number": {
          "value": 104,
          "density": {
            "enable": true,
            "value_area": 768
          }
        },
        "color": {
          "value": "#ffffff"
        },
        "shape": {
          "type": "star"
        },
        "image": {
          "width": 100,
          "height": 100
        },
        "opacity": {
          "value": 1,
          "random": false,
          "anim": {
            "enable": true,
            "speed": 0.2,
            "opacity_min": 0,
            "sync": false
          }
        },
        "size": {
          "value": 1.5,
          "random": true,
          "anim": {
            "enable": true,
            "speed": 2,
            "size_min": 0,
            "sync": false
          }
        },
        "line_linked": {
          "enable": false
        },
        "move": {
          "enable": true,
          "speed": 4,
          "direction": "bottom-left",
          "random": false,
          "straight": true
        }
      },
      "interactivity": {
        "detect_on": "canvas",
        "events": {
          "onhover": {
            "enable": false
          },
          "onclick": {
            "enable": false
          },
          "resize": true
        }
      },
      "retina_detect": true
    }
    );
  }

  $(window).on(
    'load resize orientationchange',
    normalizeSlideHeights);

  $('.second-button').on('click', function () {
    $('.animated-icon2').toggleClass('open');
  });

  $('.scroll1').click(function () {
    var sectionTo = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(sectionTo).offset().top
    }, 500);
  });

  $('.scroll2').click(function () {
    var sectionTo = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(sectionTo).offset().top
    }, 1000);
  });

  // Services Enquiry Form
  $("#enquiryForm").validate({
    submitHandler: function (form) {
      $("#phone_field").val(user_telephone_iti.getNumber());
      $("#serviceRegisterSubmitBtn").prop("disabled", true).html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Submitting...");
      $.ajax({
        url: $(form).attr('action'),
        type: "POST",
        data: $(form).serialize(),
        dataType: "json",
        success: function (response) {
          $('#registerModal').modal('hide');
          $("#serviceRegisterSubmitBtn").prop("disabled", false).html("Register");
          $('#registerCompleteModal').modal('show');
        },
        error: function (xhr) {
          var message = "<p id='recpatcha-error' class='text-danger'>" + JSON.parse( xhr.responseText)["message"] + "</p>";
          $("#recaptcha-container").append(message);
          $("#serviceRegisterSubmitBtn").prop("disabled", false).html("Send");
        }
      });
    },
    rules: {
      last_name: { notEqualTo: "#first_name" },
      email: { email: true },
      phone: { phone: true }
    }
  });

  // Contact Us Form
  $("#contactUsForm").validate({
    submitHandler: function (form) {
      $("#phone_field").val(user_telephone_iti.getNumber());
      $("#contactFormSubmitBtn").prop("disabled", true).html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Submitting...");
      $.ajax({
        url: $(form).attr('action'),
        type: "POST",
        data: $(form).serialize(),
        dataType: "json",
        success: function (response) {
          $("#contactFormSubmitBtn").prop("disabled", false).html("Send");
          $('#contactUsCompleteModal').modal('show');
        },
        error: function (xhr) {
          var message = "<p id='recpatcha-error' class='text-danger'>" + JSON.parse( xhr.responseText)["message"] + "</p>";
          $("#recaptcha-container").append(message);
          $("#contactFormSubmitBtn").prop("disabled", false).html("Send");
        }
      });
    },
    rules: {
      last_name: { notEqualTo: "#contact_first_name" },
      email: { email: true },
      phone: { phone: true }
    }
  });
  // Ebook Newsletter Subscription Form
  $("#ebookNewsletterForm").validate({
    submitHandler: function (form) {
      $("#ebookNewsletterRegisterSubmitBtn").prop("disabled", true).html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Submitting...");
      $.ajax({
        url: $(form).attr('action'),
        type: "POST",
        data: $(form).serialize(),
        dataType: "json",
        success: function (response) {
          $('#subscribeModal').modal('hide');
          $("#ebookNewsletterRegisterSubmitBtn").prop("disabled", false).html("Subscribe & Download e-Book");
          $('#eBookCompleteModal').modal('show');
        },
        error: function (xhr) {
          var message = "<p id='recpatcha-error' class='text-danger'>" + JSON.parse( xhr.responseText)["message"] + "</p>";
          $("#recaptcha-container-ebook").append(message);
          $("#ebookNewsletterRegisterSubmitBtn").prop("disabled", false).html("Send");
        }
      });
    },
    rules: {
      last_name: { notEqualTo: "#ebook_first_name" },
      email: { email: true }
    }
  });

  // Ivy Leagues Ebook Newsletter Subscription Form
  $("#IvyLeagueEbookNewsletterForm").validate({
    submitHandler: function (form) {
      $("#IvyLeagueEbookNewsletterRegisterSubmitBtn").prop("disabled", true).html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Submitting...");
      $.ajax({
        url: $(form).attr('action'),
        type: "POST",
        data: $(form).serialize(),
        dataType: "json",
        success: function (response) {
          $('#subscribeModalIvyLeague').modal('hide');
          $("#IvyLeagueEbookNewsletterRegisterSubmitBtn").prop("disabled", false).html("Subscribe & Download e-Book");
          $('#eBookCompleteModal').modal('show');
        },
        error: function (xhr) {
          var message = "<p id='recpatcha-error' class='text-danger'>" + JSON.parse( xhr.responseText)["message"] + "</p>";
          $("#recaptcha-container-ivy-league").append(message);
          $("#IvyLeagueEbookNewsletterRegisterSubmitBtn").prop("disabled", false).html("Send");
        }
      });
    },
    rules: {
      last_name: { notEqualTo: "#ivy_ebook_first_name" },
      email: { email: true }
    }
  });

  // Newsletter Subscription Form
  $("#newsletterForm").validate({
    submitHandler: function (form) {
      $("#newsletterSubmitBtn").prop("disabled", true).html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Submitting...");
      $.ajax({
        url: $(form).attr('action'),
        type: "POST",
        data: $(form).serialize(),
        dataType: "json",
        success: function (response) {
          $("#newsletterSubmitBtn").prop("disabled", false).html("Subscribe");
          $('#subscribeCompleteModal').modal('show');
        },
        error: function (xhr) {
          // Error pages (e.g. 422/500) respond with HTML, not JSON, so fall back to a generic message.
          var text = "Something went wrong. Please refresh the page and try again.";
          try { text = JSON.parse(xhr.responseText)["message"] || text; } catch (e) {}
          $("#recaptcha-container-newsletter #recpatcha-error").remove();
          $("#recaptcha-container-newsletter").append("<p id='recpatcha-error' class='text-danger'>" + text + "</p>");
          $("#newsletterSubmitBtn").prop("disabled", false).html("Subscribe");
        }
      });
    },
    rules: {
      last_name: { notEqualTo: "#newsletter_first_name" },
      email: { email: true }
    }
  });

  $('#registerModal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget) // Button that triggered the modal
    var pipeline = button.data('pipeline') // Extract service pipeline from data-pipeline
    var deal = button.data('deal') // Extract education year from data-year
    var title = button.data('title') // Extract title for Registration Form Title
    var modal = $(this)
    modal.find('.registrationPipeline').append('<input type="hidden" name="interested_services" value="' + deal + '">')
    modal.find('.registrationPipeline').append('<input type="hidden" name="pipeline" value="' + pipeline + '">')
    modal.find('.registrationPipeline').append('<input type="hidden" name="registered_subject" value="' + title + ' - ' + deal + '">')
    modal.find('.modal-title').text(title)
  });

  $('#registerModal').on('hide.bs.modal', function () {
    var modal = $(this)
    modal.find('.registrationPipeline').empty()
    modal.find('.modal-title').empty()
  });
  
  $('.collapse.collapscroll').on('show.bs.collapse', function(e) {
    var $card = $(this).closest('.card');
    var $open = $($(this).data('parent')).find('.collapse.show');
    
    var additionalOffset = 0;
    if($card.prevAll().filter($open.closest('.card')).length !== 0)
    {
          additionalOffset =  $open.height();
    }
    $('html,body').animate({
      scrollTop: $card.offset().top - additionalOffset - 100
    }, 500);
  });

  $('.clarissa-vid').click(function () {
    $(this).empty()
    $(this).append('<stream src="812f3f5c76f6aa360d9b4fd0d1624b72" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=812f3f5c76f6aa360d9b4fd0d1624b72"></script>')
  });
  $('.sachdev-vid').click(function () {
    $(this).empty()
    $(this).append('<stream src="739f3d135df7c2debf4c52a1641394df" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=739f3d135df7c2debf4c52a1641394df"></script>')
  });
  $('.academy-vid').click(function () {
    $(this).empty()
    $(this).append('<stream src="fb3f81d511231659905751baa7e1ecaa" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=fb3f81d511231659905751baa7e1ecaa"></script>')
  });
  $('.university-admissions-vid').click(function () {
    $(this).empty()
    $(this).append('<stream src="a2142f1ab21cdac269ec6b746c237e13" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=a2142f1ab21cdac269ec6b746c237e13"></script>')
  });
  $('.boarding-school-vid').click(function () {
    $(this).empty()
    $(this).append('<stream src="93e627ced5b9dc7172e2ab465e476a17" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=93e627ced5b9dc7172e2ab465e476a17"></script>')
  });
  $('.tutoring-vid').click(function () {
    $(this).empty()
    $(this).append('<stream src="3b53e0a1cfe73fa7b1db2532e4769d66" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=3b53e0a1cfe73fa7b1db2532e4769d66"></script>')
  });

  //Hide Top Bar on Scroll
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      document.getElementById("main-nav").style.top = "36px";
    } else {
      document.getElementById("main-nav").style.top = "0px";
    }
    prevScrollpos = currentScrollPos;
  }

  loadWorkshops();

  //Course Filter
  var courseFilter = function() {
    var ww = document.body.clientWidth;
    if (ww < 992) {
      $('#courseFilters #filters.collapse').removeClass('show');
    } else if (ww >= 992) {
      $('#courseFilters #filters.collapse').addClass('show');
    };
  };
  $(window).resize(function(){
    courseFilter();
  });
  courseFilter();

  //Mini Course List
  $('.courseList-cta .courseList-cta-close').click(function(){
    $('.courseList-cta').addClass('d-none')
  });
});

function captchaSuccess(){
  $("#recpatcha-error").remove();
};

function loadWorkshops() {
  var xhr = $.getJSON("https://blog.prep.works/wp-json/wp/v2/posts?_embed&per_page=3&categories=22&page=" + workshop_list_pagination + "", function (data) {
    workshop_list_pagination++;

    $.each(data, function (index, value) {
      var blog_date = new Date(Date.parse(value.date));
      var blog_post_container = "<div class='col-12 col-md-4 mb-4 pb-4'></div>"
      var blog_post = $.parseHTML(blog_post_container);
      if (value._embedded.hasOwnProperty('wp:featuredmedia')) {
        $(blog_post).append("<a href=" + value.link + " class='blog-img-link'><div class='mb-3 rounded-xl bg-white blog-img shadow'><img class='w-100' src=" + value._embedded['wp:featuredmedia']['0'].source_url + "></div></a>");
      }
      $(blog_post).append("<p class='mb-1'><small>" + blog_date.toDateString() + "</small></p>");
      $(blog_post).append("<a href=" + value.link + " class='text-dark text-decoration-none blog-title'><h5 class='font-weight-bold mb-4 pb-2'>" + value.title.rendered + "</h5></a>");
      $(blog_post).append("<div class='workshop-btn'><a href=" + value.link + " class='btn btn-danger btn-pill'>Find out more</a></div>");
      $workshop_list.append(blog_post);
      $("#blog_preloader").remove();
    });
  });
}

// Registration Form — cascade State dropdown when Country changes
$(document).on('change', '#student_country_select', function() {
  var $country = $(this);
  var $state = $('#student_state_select');
  var code = $country.val();
  $state.prop('disabled', true).empty().append('<option value="">Loading…</option>');

  if (!code) {
    $state.empty().append('<option value="">State*</option>').prop('disabled', true);
    return;
  }

  var template = $state.data('subregions-url-template') || '/subregions/XX';
  var url = template.replace(/XX$/, encodeURIComponent(code));

  $.getJSON(url)
    .done(function(subregions) {
      $state.empty();
      if (!subregions || subregions.length === 0) {
        $state.append('<option value="N/A" selected>Not applicable</option>').prop('disabled', false);
        return;
      }
      $state.append('<option value="">State*</option>');
      $.each(subregions, function(_i, r) {
        $state.append($('<option>').val(r.code).text(r.name));
      });
      $state.prop('disabled', false);
    })
    .fail(function() {
      $state.empty().append('<option value="">Error loading states — please refresh</option>').prop('disabled', true);
    });
});

// Registration Form — Terms & Conditions scroll-to-enable
var prepworksTermsRead = false;

function prepworksCheckTermsScroll() {
  var body = document.getElementById('termsModalBody');
  if (!body) return;
  var nearBottom = (body.scrollHeight - body.scrollTop - body.clientHeight) < 20;
  if (nearBottom && !prepworksTermsRead) {
    prepworksTermsRead = true;
    $('#terms_accepted_checkbox').prop('disabled', false);
    $('#termsScrollPrompt').remove();
  }
}

$(document).on('shown.bs.modal', '#termsModal', function() {
  // Scroll events don't bubble, so we have to bind directly to the scrolling element.
  $('#termsModalBody').off('scroll.prepworksTerms').on('scroll.prepworksTerms', prepworksCheckTermsScroll);
  setTimeout(prepworksCheckTermsScroll, 100);
});

// Registration Form Response Handler
//
// IMPORTANT: this is bound as a native CAPTURE-phase listener (note the `true` as the
// final argument to addEventListener, far below), NOT jQuery's
// $(document).on('submit', ...). That capture-phase binding is the core fix for the
// "registration form stops working after ~2 minutes" bug. Why it matters:
//
// reCAPTCHA v3 tokens expire after ~2 min and are single-use, so we must refresh the
// token at submit time. BUT rails-ujs (started in the `application` pack, which loads
// in <head>) also listens for this form's submit — in the BUBBLE phase — and it loads
// BEFORE the `homepage` pack (loaded at the end of <body>). If we listened in the
// bubble phase too, rails-ujs would run first and fire the AJAX request carrying the
// STALE page-load token before our refresh ever ran. That is exactly the bug: under
// 2 min the page-load token is still valid (form works), over 2 min it is expired and
// Google rejects it with "timeout-or-duplicate" → "Please confirm you are human!".
//
// Listening in the capture phase guarantees we run FIRST: we cancel this submit, fetch
// a fresh token, drop it into the hidden field, then re-fire so rails-ujs sends the
// request with the new token. Do NOT convert this back to $(document).on('submit', ...)
// and do NOT drop the trailing `true` — either change reintroduces the 2-minute bug.
document.addEventListener('submit', function(event) {
  var form = event.target;
  if (!form || form.id !== 'registrationForm') { return; }
  var $form = $(form);
  $('#registrationForm-error').remove();

  var studentFirst = ($('#registrationForm [name="student_firstname"]').val() || '').trim();
  var studentLast = ($('#registrationForm [name="student_lastname"]').val() || '').trim();
  if (studentFirst && studentLast && studentFirst.toLowerCase() === studentLast.toLowerCase()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var nameMsg = "<p id='registrationForm-error' class='text-danger mt-2'>The student's first and last name can't be the same — please check the name fields.</p>";
    $("#recaptcha-container").append(nameMsg);
    return false;
  }

  var studentEmail = ($('#registrationForm [name="student_email"]').val() || '').trim().toLowerCase();
  var guardianEmail = ($('#registrationForm [name="guardian_email"]').val() || '').trim().toLowerCase();
  if (studentEmail && studentEmail === guardianEmail) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var message = "<p id='registrationForm-error' class='text-danger mt-2'>Student email and guardian email must be different.</p>";
    $("#recaptcha-container").append(message);
    return false;
  }

  if (!$('#terms_accepted_checkbox').is(':checked')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var msg = "<p id='registrationForm-error' class='text-danger mt-2'>Please review and agree to the Terms &amp; Conditions before submitting.</p>";
    $("#recaptcha-container").append(msg);
    return false;
  }

  // reCAPTCHA v3 tokens expire after ~2 minutes and are single-use. The token
  // generated at page load is almost always stale by the time this long form is
  // submitted, which makes the server reject it ("Please confirm you are human!").
  // So fetch a fresh token now, drop it into the hidden field, then re-submit.

  // A fresh token was already fetched in the first pass of this same submit;
  // let this second (programmatic) submission through so rails-ujs sends it.
  if ($form.data('recaptchaRefreshed')) {
    $form.data('recaptchaRefreshed', false);
    return;
  }

  // NOTE: the function name MUST be capital-R "Registration". The recaptcha gem
  // camelizes the action ('registration' -> 'Registration') when it generates
  // executeRecaptchaForRegistrationAsync(). Using lowercase 'registration' here
  // silently no-ops the refresh and submits a stale page-load token (which
  // expires after ~2 min), so slow form-fillers get "Please confirm you are
  // human!". Do not "correct" the casing.
  //
  // If the function is missing entirely, Google's script never loaded (mobile
  // Safari "Prevent Cross-Site Tracking", ad/content blockers, or a slow
  // connection). Stop and tell the customer instead of submitting an empty token.
  if (typeof executeRecaptchaForRegistrationAsync !== 'function') {
    event.preventDefault();
    event.stopImmediatePropagation();
    $("#recaptcha-container").append("<p id='registrationForm-error' class='text-danger mt-2'>Security check (reCAPTCHA) hasn't finished loading yet. Please wait a few seconds and tap Submit again. If it keeps happening, turn off any ad/content blocker for this site, or try a different browser.</p>");
    return false;
  }

  // Fetch a fresh token, drop it into the hidden field, then re-submit.
  event.preventDefault();
  event.stopImmediatePropagation();
  executeRecaptchaForRegistrationAsync().then(function(token) {
    $('#g-recaptcha-response-data-registration').val(token);
    $form.data('recaptchaRefreshed', true);
    if (window.Rails) {
      window.Rails.fire($form[0], 'submit');
    } else {
      $form[0].submit();
    }
  }).catch(function() {
    $("#recaptcha-container").append("<p id='registrationForm-error' class='text-danger mt-2'>Couldn't verify reCAPTCHA. Please refresh the page and try again.</p>");
  });
  return false;
}, true);

$(document).on('ajax:success', '#registrationForm', function(event) {
  $('#registrationForm-error, #recpatcha-error').remove();
  $('#registrationCompleteModal').modal('show');
});

$(document).on('ajax:error', '#registrationForm', function(event) {
  $('#registrationForm-error, #recpatcha-error').remove();
  var detail = event.detail || (event.originalEvent && event.originalEvent.detail) || [];
  var data = detail[0];
  var xhr  = detail[2];
  var serverMessage = null;
  if (data && typeof data === 'object' && data.message) {
    serverMessage = data.message;
  } else if (xhr && xhr.responseText) {
    try { serverMessage = JSON.parse(xhr.responseText).message; } catch (_e) { /* not JSON */ }
  }
  var text = serverMessage || 'Something went wrong. Please try again.';
  var message = "<p id='registrationForm-error' class='text-danger mt-2'>" + text + "</p>";
  $("#recaptcha-container").append(message);
});